import { gql } from 'graphql-request';

export const GET_OPPORTUNITIES = gql`
  query (
    $first: Int
    $after: String
    $job_types: [String!]
    $unions: [String!]
    $genders: [String!]
    $paying_roles: [String!]
    $age_range_from: Int
    $age_range_to: Int
    $age_range_type: String
    $countries: [String!]
    $cities: [String!]
    $tab_filter: String
    $project_ids: [ID!]
    $role_ids: [ID!]
  ) {
    opportunities_connection(
      first: $first
      after: $after
      jobTypes: $job_types
      unions: $unions
      genders: $genders
      payingRoles: $paying_roles
      ageRangeFrom: $age_range_from
      ageRangeTo: $age_range_to
      ageRangeType: $age_range_type
      countries: $countries
      cities: $cities
      tabFilter: $tab_filter
      projectIds: $project_ids
      roleIds: $role_ids
    ) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      nodes {
        id
        slug
        noticeboard_project_name
        noticeboard_company_name
        name
        union
        rate
        usage
        company {
          name
          addresses {
            city_suburb
            state_code
          }
        }
        working
        opportunities_aggregates
        project_type
        casting_roles {
          mediumable_count
          slug
          id
          name
          country
          genders
          submission_date_due
          working
          fitting
          age_range_from
          age_range_to
          age_range_type
          rate_information
          ethnic_appearance
          talent_description
        }
      }
    }
  }
`;

export const GET_PROJECT = gql`
  query ($id: ID!) {
    public_projects_on_notice_board(id: $id) {
      conflicts
      usage
      additional_details
      medium_attachments {
        id
        attachment
        medium {
          file_type
          file_name
        }
      }
    }
  }
`;

export const GET_PROJECT_WITH_ROLES = gql`
  query ($id: ID, $project_slug: String) {
    public_projects_on_notice_board(id: $id, projectSlug: $project_slug) {
      name
      id
      ongoing_session {
        id
        required_signed_nda
        nda_content
      }
      casting_roles {
        name
        id
      }
    }
  }
`;

export const GET_PUBLIC_PROJECT = gql`
  query ($id: ID, $project_slug: String) {
    public_projects_on_notice_board(id: $id, projectSlug: $project_slug) {
      id
      slug
      name
      union
      rate
      usage
      company {
        name
        addresses {
          city_suburb
          state_code
        }
        logo
      }
      working
      opportunities_aggregates
      project_type
      conflicts
      usage
      additional_details
      medium_attachments {
        id
        attachment
        medium {
          file_type
          file_name
        }
      }
    }
  }
`;

export const GET_ROLE = gql`
  query ($id: ID!) {
    public_roles_on_notice_board(id: $id) {
      audition
      wardrobe
      medium_attachments {
        attachment
        medium {
          file_type
          file_name
        }
      }
      reference_urls
    }
  }
`;

export const GET_PUBLIC_ROLE = gql`
  query ($id: ID, $slug: String!) {
    public_roles_on_notice_board(id: $id, slug: $slug) {
      id
      slug
      name
      country
      genders
      submission_date_due
      working
      fitting
      age_range_from
      age_range_to
      age_range_type
      rate_information
      ethnic_appearance
      talent_description
      audition
      wardrobe
      medium_attachments {
        attachment
        medium {
          file_type
          file_name
        }
      }
      reference_urls
    }
  }
`;

export const GET_PROJECT_ROLES = gql`
  query (
    $first: Int
    $after: String
    $project_ids: [ID!]
    $role_ids: [ID!]
    $except_role_ids: [ID!]
    $project_slugs: [ID!]
    $role_slugs: [ID!]
    $except_role_slugs: [ID!]
  ) {
    casting_role_opportunities_connection(
      first: $first
      after: $after
      projectIds: $project_ids
      roleIds: $role_ids
      exceptRoleIds: $except_role_ids
      projectSlugs: $project_slugs
      roleSlugs: $role_slugs
      exceptRoleSlugs: $except_role_slugs
    ) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      nodes {
        id
        slug
      }
    }
  }
`;

export const GET_PROJECT_ROLES_COMPLETE = gql`
  query (
    $first: Int
    $after: String
    $project_ids: [ID!]
    $role_ids: [ID!]
    $except_role_ids: [ID!]
    $project_slugs: [ID!]
    $role_slugs: [ID!]
    $except_role_slugs: [ID!]
  ) {
    casting_role_opportunities_connection(
      first: $first
      after: $after
      projectIds: $project_ids
      roleIds: $role_ids
      exceptRoleIds: $except_role_ids
      projectSlugs: $project_slugs
      roleSlugs: $role_slugs
      exceptRoleSlugs: $except_role_slugs
    ) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      nodes {
        mediumable_count
        slug
        id
        name
        country
        genders
        submission_date_due
        working
        fitting
        age_range_from
        age_range_to
        age_range_type
        rate_information
        ethnic_appearance
        talent_description
      }
    }
  }
`;
